import { render, staticRenderFns } from "./ChatChannel.vue?vue&type=template&id=0e6d444e&scoped=true"
import script from "./ChatChannel.vue?vue&type=script&lang=ts"
export * from "./ChatChannel.vue?vue&type=script&lang=ts"
import style0 from "./ChatChannel.vue?vue&type=style&index=0&id=0e6d444e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6d444e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e6d444e')) {
      api.createRecord('0e6d444e', component.options)
    } else {
      api.reload('0e6d444e', component.options)
    }
    module.hot.accept("./ChatChannel.vue?vue&type=template&id=0e6d444e&scoped=true", function () {
      api.rerender('0e6d444e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chat/ChatChannel.vue"
export default component.exports